export default __webpack_public_path__ + "static/media/ticket.ffb3d668.svg";